/**
 * @enum RegistrationState
 * @description Supported Reg state
 */
enum RegistrationState {
  CONFIGURATION = "CONFIGURATION",
  ON_GOING = "ON_GOING",
  PAUSED = "PAUSED",
  ELAPSED = "ELAPSED"
}

export default RegistrationState;
